
const HPStateMachineConfig = {

    Loan: {
        Application_Submitted: 26,
        AUS_Reviewed: 27,
        AUS_Denied: 28,
        AUS_Conditionally_Approved: 29,
        UW_Reviewed_Info_Needed: 30,
        Decision_Info_Received: 31,
        Application_Denied: 32,
        Application_Terminated: 33,
        Application_Approved: 12,
        Product_And_Price_Added: 13,
        Products_Submitted: 34,
        Fin_Docs_Sent: 1,
        // Fin Docs state machine begins
        Fin_Docs_Signed_By_All_PO: 11,
        // Funding request state machine begins
        Final: 254,
        Unknown: 255,
    },

    CC: {
        Completion_Cert_Generated: 1,
        Product_Details_Confirmed: 2,
        Payment_Instructions_Confirmed: 3,
        CO_Signed_Completion_Cert: 4,
        CO_Emailed_PO_Completion_Cert: 5,
        Completion_Cert_Sent_To_Installer:	6,
        PO_Initiated_Completion_Cert_eSign:	7,
        PO_Completed_Completion_Cert_eSign:	8,
        Completion_Cert_Uploaded_Or_eSigned: 9,
        Unknown: 255,
    },

    ACA: {
        No_ACA: 0,
        ACA_Generated:	1,
        CO_Emailed_PO_ACA: 2,
        ACA_Sent_To_Installer: 3,
        PO_Initiated_ACA_eSign: 4,
        PO_Completed_ACA_eSign: 5,
        ACA_Signed_By_All_PO: 6,
        COG_Countersigned_ACA: 7,
        Unknown: 255,
    },

    FR: {
        Project_Started: 1,
        Project_Completed: 2,
        All_Documents_Uploaded_Or_Signed: 3,
        Documents_Submitted: 4,
        Closer_Accepted_Case: 5,
        HERO_Funding_Scheduled: 6,
        HERO_Funded: 7,
        Closer_Rejected_Documents: 8,
        CO_Corrects_Documents: 9,
        Application_Denied: 10,
        HLP_Recording_Scheduled: 11,
        HLP_Completed: 12,
        Final: 254,
        Unknown: 255,
    },

    FD: {
        Fin_Docs_Created: 1,
        Fin_Docs_Approved_By_CO: 2,
        Fin_Docs_Emailed_To_PO: 3,
        Fin_Docs_eSign_Initiated_By_PO: 4,
        Fin_Docs_Signed_By_PO: 5,
        Fin_Docs_Signed_By_All_PO: 6,
        Issuer_Reviewed: 7,
        Issuer_Countersigned: 8,
        Unknown: 255,
    },
};

export default HPStateMachineConfig;



// WEBPACK FOOTER //
// ./src/app/config/constants/StateMachine.constant.js